import React from 'react';
import {
    ListButton,
    Responsive,
    SimpleList,
    TextField,
    SimpleShowLayout,
} from 'admin-on-rest';
import NanoEventEmitter from 'nano-event-emitter';
import List from '../admin/List';
import Show from '../admin/ShowLocationAudit';
import DatagridLocationAudit from '../admin/DatagridLocationAudit';
import LocationAuditTable from '../components/LocationAuditTable';
import LocationAuditsIconButton from '../buttons/LocationAuditsIconButton';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {CardActions} from 'material-ui/Card';
import Icon from 'material-ui/svg-icons/action/assignment';

export const fuseLocationAuditIcon = Icon;

const MakeLocationAuditTable = ({record, history, listUrl, canEdit}) => {
    return (
        <LocationAuditTable {...record} history={history} listUrl={listUrl} canEdit={canEdit}/>
    )
};

// Handle toggle event (if state/props is used)
const handleLocationAuditToggleEvent = (e, id, is_auditing, is_final_auditing, expanded) => {
    return {id: id, is_auditing: is_auditing, is_final_auditing: is_final_auditing, expanded: expanded};
};

/*
 * View: List
 */

const ListEventEmitter = NanoEventEmitter.create();

// Set title for List Location Audits
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                className="avatar-title"/>Location Audits</span>;

const ListDescription = () => {
    return (
        <span>
            <p>Below are listed all Locations marked as currently auditing. Toggle each Location to view its Normal
                Audit or Final Audit. Click the Audit's View icon to review its contents and approve or update the
                Audit.</p>
        </span>
    );
};

export const fuseLocationAuditList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} sort={{field: 'id', order: 'ASC'}} perPage={20}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.city}
                    tertiaryText={record => record.id}
                />
            }
            medium={
                <DatagridLocationAudit bodyOptions={{stripedRows: false, showRowHover: true}}
                                       columns={6}
                                       eventEmitter={ListEventEmitter}
                                       toggleEventName="locationAuditToggle"
                                       currentToggle={{id: '', expanded: false}}
                >
                    <TextField source="id" label="ID"/>
                    <TextField source="name" label="Name"/>
                    <TextField source="city" label="City"/>
                    <TextField source="state" label="State"/>
                    <LocationAuditsIconButton
                        eventEmitter={ListEventEmitter}
                        expanded={false}
                        toggleEventName="locationAuditToggle"
                        onToggleClick={handleLocationAuditToggleEvent}
                    />
                </DatagridLocationAudit>
            }
        />
    </List>
);

/*
 * View: Show/Edit
 */

// Set title for Show Location Audit
const ShowTitle = () => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Location Audit</span>;
};

// Replace Actions for Show Location Audit
const ShowActions = ({basePath, data, canEdit}) => {
    return (
        <CardActions style={viewStyles.actions}>
            <ListButton basePath="/LocationAudits"/>
        </CardActions>
    )
};

/*
 * Show/Edit Location Audit Table
 *
 */
export const fuseLocationAuditShow = ({canEdit, ...props}) => {
    return (
        <Show {...props} title={<ShowTitle/>} actions={<ShowActions canEdit={canEdit}/>}>
            <SimpleShowLayout>
                <TextField source="message" label=""/>
                <TextField source="audit_uuid" label="Audit UUID"/>
                <TextField source="location_id" label="Location"/>
                <hr style={viewStyles.break}/>
                <MakeLocationAuditTable listUrl="/LocationAudits" canEdit={canEdit} {...props}/>
            </SimpleShowLayout>
        </Show>
    )
};





// WEBPACK FOOTER //
// ./src/Fuse/Inventory/locationAudit.js